import useText from '@/hooks/useText';
import RestrictedAccess from '@/components/Modal/RestrictedAccess';
import { userAppContext } from '@/context/Context';
import { buildToolAccessContext, canUseTool, getToolAccess } from '@/components/Tools/toolAccess';

export default function RInstallation() {
  const installationText = useText('rpackage.installation');
  const examplesText = useText('rpackage.examples');
  const { user, isAuthenticated } = userAppContext();
  const accessCtx = buildToolAccessContext(isAuthenticated, user?.['cognito:groups']);
  const access = getToolAccess('r-package', accessCtx);
  const isRestricted = !canUseTool('r-package', accessCtx);

  return (
    <div>
      <p>
        The package disgenet2r is available through GitLab. The package requires an R version greater than
        3.5.
      </p>
      <RestrictedAccess
        isRestricted={isRestricted}
        restrictedMessage={
          <h6>
            {access.reason ?? 'The R package is not included in your current plan.'}{' '}
            <a href={access.upgradeHref} style={{ color: '#D02591' }}>
              {access.status === 'login' ? 'Sign in' : 'See plans'}
            </a>
            .
          </h6>
        }
      >
        <p>
          Get it at{' '}
          <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
            https://gitlab.com/medbio/disgenet2r
          </a>
          . You can install disgenet2r by typing the following commands in R:
        </p>
        <pre
          style={{
            backgroundColor: '#f6f8fa',
            padding: '10px',
            borderRadius: '5px',
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace;',
            whiteSpace: 'pre-wrap',
          }}
        >
          <code>{`library(devtools)
install_gitlab("medbio/disgenet2r")`}</code>
        </pre>
        <div>
          <p>
            {installationText}{' '}
            <a href="https://medbio.gitlab.io/disgenet2r/" target="_blank" rel="noopener noreferrer">
              {examplesText}
            </a>
          </p>
        </div>
      </RestrictedAccess>
    </div>
  );
}
